export class UpdateUserHasQualificationHasFileDto {}
